export const getCardOrientation = (index, column) => {
  if (column === "left") {
    // Every third image (1-based index) is horizontal
    return (index + 1) % 3 === 0 ? "horizontal" : "vertical";
  }

  if (column === "right") {
    // Every odd image (0-based index) is vertical
    return index % 2 !== 0 ? "vertical" : "horizontal";
  }

  // Optional fallback
  return "vertical"; // or throw an error if column is invalid
};
